import Cookies from "js-cookie"

export function isAdminLogged() {
    if (Cookies.get("AuthorizationGoatechIsAdmin")) {
        return true;
    }
    return false;
}